import React from "react";

import FormSection from "../../common/FormSection";
import FormStep from "../../common/FormStep";
import InputField from "../../common/InputField";
import RadioField from "../../common/RadioField";
import SelectField from "../../common/SelectField";

const stateOptions = [
  {
    name: "Alabama",
    value: "AL",
  },
  {
    name: "Alaska",
    value: "AK",
  },
  {
    name: "American Samoa",
    value: "AS",
  },
  {
    name: "Arizona",
    value: "AZ",
  },
  {
    name: "Arkansas",
    value: "AR",
  },
  {
    name: "California",
    value: "CA",
  },
  {
    name: "Colorado",
    value: "CO",
  },
  {
    name: "Connecticut",
    value: "CT",
  },
  {
    name: "Delaware",
    value: "DE",
  },
  {
    name: "District Of Columbia",
    value: "DC",
  },
  {
    name: "Federated States Of Micronesia",
    value: "FM",
  },
  {
    name: "Florida",
    value: "FL",
  },
  {
    name: "Georgia",
    value: "GA",
  },
  {
    name: "Guam",
    value: "GU",
  },
  {
    name: "Hawaii",
    value: "HI",
  },
  {
    name: "Idaho",
    value: "ID",
  },
  {
    name: "Illinois",
    value: "IL",
  },
  {
    name: "Indiana",
    value: "IN",
  },
  {
    name: "Iowa",
    value: "IA",
  },
  {
    name: "Kansas",
    value: "KS",
  },
  {
    name: "Kentucky",
    value: "KY",
  },
  {
    name: "Louisiana",
    value: "LA",
  },
  {
    name: "Maine",
    value: "ME",
  },
  {
    name: "Marshall Islands",
    value: "MH",
  },
  {
    name: "Maryland",
    value: "MD",
  },
  {
    name: "Massachusetts",
    value: "MA",
  },
  {
    name: "Michigan",
    value: "MI",
  },
  {
    name: "Minnesota",
    value: "MN",
  },
  {
    name: "Mississippi",
    value: "MS",
  },
  {
    name: "Missouri",
    value: "MO",
  },
  {
    name: "Montana",
    value: "MT",
  },
  {
    name: "Nebraska",
    value: "NE",
  },
  {
    name: "Nevada",
    value: "NV",
  },
  {
    name: "New Hampshire",
    value: "NH",
  },
  {
    name: "New Jersey",
    value: "NJ",
  },
  {
    name: "New Mexico",
    value: "NM",
  },
  {
    name: "New York",
    value: "NY",
  },
  {
    name: "North Carolina",
    value: "NC",
  },
  {
    name: "North Dakota",
    value: "ND",
  },
  {
    name: "Northern Mariana Islands",
    value: "MP",
  },
  {
    name: "Ohio",
    value: "OH",
  },
  {
    name: "Oklahoma",
    value: "OK",
  },
  {
    name: "Oregon",
    value: "OR",
  },
  {
    name: "Palau",
    value: "PW",
  },
  {
    name: "Pennsylvania",
    value: "PA",
  },
  {
    name: "Puerto Rico",
    value: "PR",
  },
  {
    name: "Rhode Island",
    value: "RI",
  },
  {
    name: "South Carolina",
    value: "SC",
  },
  {
    name: "South Dakota",
    value: "SD",
  },
  {
    name: "Tennessee",
    value: "TN",
  },
  {
    name: "Texas",
    value: "TX",
  },
  {
    name: "Utah",
    value: "UT",
  },
  {
    name: "Vermont",
    value: "VT",
  },
  {
    name: "Virgin Islands",
    value: "VI",
  },
  {
    name: "Virginia",
    value: "VA",
  },
  {
    name: "Washington",
    value: "WA",
  },
  {
    name: "West Virginia",
    value: "WV",
  },
  {
    name: "Wisconsin",
    value: "WI",
  },
  {
    name: "Wyoming",
    value: "WY",
  },
];

const countryOptions = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua & Deps",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Central African Rep",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo",
  "Congo {Democratic Rep}",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "East Timor",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland {Republic}",
  "Israel",
  "Italy",
  "Ivory Coast",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea North",
  "Korea South",
  "Kosovo",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar, {Burma}",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russian Federation",
  "Rwanda",
  "St Kitts & Nevis",
  "St Lucia",
  "Saint Vincent & the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome & Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Togo",
  "Tonga",
  "Trinidad & Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
].map((country) => ({ name: country, value: country }));

const revenueOptions = [
  {
    name: "Less than $30,000 total revenue as a result of subcontracting to an Alutiiq subsidiary",
    value: "Less Than 30K",
  },
  {
    name: "More than $30,000 total revenue as a result of subcontracting to an Alutiiq subsidiary",
    value: "More Than 30K",
  },
];

const lineOfBusinessOptions = [
  { name: "Construction", value: "Construction" },
  { name: "Logistics, Ops, & Maint", value: "Logistics, Ops & Maint" },
  {
    name: "Security and Professional/Technical Services",
    value: "Security and Professional/Technical Services",
  },
  { name: "Youth Services", value: "Youth Services" },
];

const customerOptions = [
  { name: "Subcontract", value: "subcontract" },
  { name: "Teaming Agreement", value: "teamingAgreement" },
];

const alutiiqSubsidiaryOptions = [
  {
    name: "ALUTIIQ BUSINESS SERVICES LLC",
    value: "ALUTIIQ BUSINESS SERVICES LLC",
  },
  {
    name: "ALUTIIQ DIVERSIFIED SERVICES LLC",
    value: "ALUTIIQ DIVERSIFIED SERVICES LLC",
  },
  {
    name: "ALUTIIQ EDUCATION & TRAINING LLC",
    value: "ALUTIIQ EDUCATION & TRAINING LLC",
  },
  {
    name: "ALUTIIQ GLOBAL SOLUTIONS LLC",
    value: "ALUTIIQ GLOBAL SOLUTIONS LLC",
  },
  { name: "ALUTIIQ MELE LLC", value: "ALUTIIQ MELE LLC" },
  {
    name: "ALUTIIQ MANUFACTURING CONTRACTORS",
    value: "ALUTIIQ MANUFACTURING CONTRACTORS",
  },
  {
    name: "ALUTIIQ MANAGEMENT SERVICES LLC",
    value: "ALUTIIQ MANAGEMENT SERVICES LLC",
  },
  { name: "ALUTIIQ PACIFIC LLC", value: "ALUTIIQ PACIFIC LLC" },
  {
    name: "ALUTIIQ SECURITY & TECHNOLOGY LLC",
    value: "ALUTIIQ SECURITY & TECHNOLOGY LLC",
  },
  {
    name: "ALUTIIQ GENERAL CONTRACTORS LLC",
    value: "ALUTIIQ GENERAL CONTRACTORS LLC",
  },
  {
    name: "ALUTIIQ LEASING COMPANY S.DE R.L.DE C",
    value: "ALUTIIQ LEASING COMPANY S.DE R.L.DE C",
  },
  {
    name: "ALUTIIQ TECHNICAL SERVICES LLC",
    value: "ALUTIIQ TECHNICAL SERVICES LLC",
  },
  {
    name: "ALUTIIQ COMMERCIAL ENTERPRISES LLC",
    value: "ALUTIIQ COMMERCIAL ENTERPRISES LLC",
  },
  {
    name: "ALUTIIQ PROFESSIONAL TRAINING LLC",
    value: "ALUTIIQ PROFESSIONAL TRAINING LLC",
  },
  {
    name: "ALUTIIQ ADVANCED SECURITY SOLUTIONS LLC",
    value: "ALUTIIQ ADVANCED SECURITY SOLUTIONS LLC",
  },
  {
    name: "ALUTIIQ ESSENTIAL SERVICES LLC",
    value: "ALUTIIQ ESSENTIAL SERVICES LLC",
  },
  {
    name: "ALUTIIQ INFORMATION MANAGEMENT LLC",
    value: "ALUTIIQ INFORMATION MANAGEMENT LLC",
  },
  {
    name: "ALUTIIQ CONSTRUCTION SERVICES LLC",
    value: "ALUTIIQ CONSTRUCTION SERVICES LLC",
  },
  { name: "ALUTIIQ CAREER VENTURES LLC", value: "ALUTIIQ CAREER VENTURES LLC" },
  {
    name: "ALUTIIQ LOGISTICS & MAINTENANCE SVS LLC",
    value: "ALUTIIQ LOGISTICS & MAINTENANCE SVS LLC",
  },
  { name: "ALUTIIQ SOLUTIONS LLC", value: "ALUTIIQ SOLUTIONS LLC" },
  { name: "ALCYON INC", value: "ALCYON INC" },
  { name: "SHIELDS POINT LLC", value: "SHIELDS POINT LLC" },
  {
    name: "RED PEAK TECHNICAL SERVICES LLC",
    value: "RED PEAK TECHNICAL SERVICES LLC",
  },
  { name: "MCCALLIE ASSOCIATES INC", value: "MCCALLIE ASSOCIATES INC" },
];

const GeneralInfoFields = () => {
  return (
    <FormStep>
      <FormSection title="A. Company Information">
        <SelectField
          name="applicantType"
          label="1. Applicant Type"
          options={customerOptions}
        />
        <InputField name="companyName" label="2. Company legal name" />
        <InputField
          name="yearEst"
          label="3. Year incorporated"
          type="number2"
          required={true}
        />
        <SelectField
          name="stateInc"
          label="4. State of Inc."
          options={stateOptions}
        />
        <InputField
          name="yearsWithName"
          label="5. Years with present name"
          type="number2"
          required={true}
        />
        <InputField name="priorCompanyNames" label="6. Prior company names" />
        <InputField
          name="hqMailingAddress"
          label="7. Mailing address"
          required={true}
        />
        <InputField name="hqStreetAddress" label="8. Street address" />
        <InputField name="city" label="9. City" required={true} />
        <SelectField name="state" label="10. State" options={stateOptions} />
        <InputField name="zip" label="11. ZIP" required={true} />
        <SelectField
          name="country"
          label="12. Country"
          options={countryOptions}
        />
      </FormSection>

      <FormSection title="B. Point of Contact">
        <InputField name="pocFirstName" label="1. First name" required={true} />
        <InputField name="pocLastName" label="2. Last name" required={true} />
        <InputField name="pocTitle" label="3. Title" required={true} />
        <InputField
          name="pocEmail"
          label="4. Email"
          type="email"
          required={true}
        />
        <InputField
          name="pocPhoneNumber"
          label="5. Phone number (###-###-####)"
          type="tel"
          required={true}
        />
        <InputField name="pocAltEmail" label="6. Alternate email" />
      </FormSection>

      <FormSection title="C. Alutiiq Contact">
        <InputField
          name="alutiiqContactFirstName"
          label="1. First name"
          required={true}
        />
        <InputField
          name="alutiiqContactLastName"
          label="2. Last Name"
          required={true}
        />
      </FormSection>

      <FormSection
        title={
          <span>
            D. <abbr title="Defense Contract Audit Agency">DCAA</abbr> Contact
          </span>
        }
      >
        <InputField name="DCAAPOCFirstName" label="1. First name" />
        <InputField name="DCAAPOCLastName" label="2. Last name" />
        <InputField
          name="DCAAPOCPhone"
          label="3. Phone (###-###-####)"
          type="tel"
        />
        <InputField name="DCAAPOCEmail" label="4. Email" type="email" />
      </FormSection>

      <FormSection title="E. Additional Information">
        <RadioField
          name="revenue"
          label="1. My company expects to receive"
          options={revenueOptions}
        />
        <SelectField
          name="alutiiqSubsidiary"
          label="2. What Subsidiary does the application fall under?"
          options={alutiiqSubsidiaryOptions}
        />
      </FormSection>
    </FormStep>
  );
};

export default GeneralInfoFields;
